/* ============================================================================
PO / PO33 Keyboard — TriLang FR/EN/ES + Lexicon Protection + Notranslate
- Traduction uniquement via boutons FR/EN/ES du bloc
- Protection lexique canonique (window.PO_LEXICON si dispo) + variantes
- Anti Google Translate / navigateur sur le bloc
- Accordéon exclusif des sous-groupes conservé
- Multi-instances Shopify-safe

✅ RÈGLE APPLIQUÉE :
- Tout ce qui est du lexique canonique (data-po-lex) reste TOUJOURS en français
- Tout le reste (slots généraux) peut être traduit FR/EN/ES
- "Fondamenteurs" est protégé comme néologisme canonique
============================================================================ */
(function(){
  "use strict";
  if (window.__PO33B_TRILANG_PROTECTED_20260304__) return;
  window.__PO33B_TRILANG_PROTECTED_20260304__ = true;

  var STORAGE_KEY = "po33b_lang";

  function normLang(raw){
    var s = String(raw || "").toLowerCase().trim().replace("_","-");
    if (s.indexOf("en") === 0) return "en";
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "es";
    return "fr";
  }

  function getLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      if (v) return normLang(v);
    }catch(_){}
    return "fr";
  }

  function setLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(_){}
    applyAll(l);
    return l;
  }

  function toStr(x){ return x == null ? "" : String(x); }

  function escapeHtml(s){
    return toStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeRegExp(s){
    return toStr(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function normalizeVariant(s){
    var x = toStr(s);
    x = x.replace(/[’`´]/g, "'");
    x = x.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    x = x.replace(/æ/g, "ae").replace(/Æ/g, "AE");
    try{ x = x.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }catch(_){}
    return x;
  }

  function lockNoTranslate(root, lang){
    try{
      root.setAttribute("translate","no");
      root.classList.add("notranslate");
      root.setAttribute("lang", lang || "fr");
    }catch(_){}
  }

  /* =========================
     LEXIQUE À PROTÉGER
     ========================= */
  var _protectTerms = null;

  function uniqTerms(list){
    var seen = Object.create(null), out = [];
    function add(x){
      x = toStr(x).trim();
      if (!x) return;
      if (seen[x]) return;
      seen[x] = true;
      out.push(x);

      var v1 = x.replace(/œ/g, "oe").replace(/Œ/g, "OE").replace(/æ/g, "ae").replace(/Æ/g, "AE");
      if (v1 && !seen[v1]) { seen[v1] = true; out.push(v1); }

      var v2 = x.replace(/[’`´]/g, "'");
      if (v2 && !seen[v2]) { seen[v2] = true; out.push(v2); }

      var v3 = normalizeVariant(x);
      if (v3 && !seen[v3]) { seen[v3] = true; out.push(v3); }
    }
    for (var i=0;i<list.length;i++) add(list[i]);
    out.sort(function(a,b){ return b.length - a.length; });
    return out;
  }

  function buildProtectTerms(){
    if (Array.isArray(window.PO33B_PROTECT_TERMS) && window.PO33B_PROTECT_TERMS.length){
      return uniqTerms(window.PO33B_PROTECT_TERMS);
    }

    var src = window.PO_LEXICON;
    if (!Array.isArray(src)){
      if (Array.isArray(window.PO_LEXICON_DATA)) src = window.PO_LEXICON_DATA;
      else if (Array.isArray(window.PO_LEXICON_ENTRIES)) src = window.PO_LEXICON_ENTRIES;
    }

    var out = [
      "Posœnnoïa","RéZonans","Péroptissimisme","Aliœvolution",
      "Katûpirsia","Fondamenteurs","Posœnnoïamie","Posœnnomia","Organon posœnnoïal",
      "Miroirs posœnnoïaux","Méditations posœnnoïales","Accords posœnnoïaux"
    ];

    if (Array.isArray(src)){
      for (var i=0;i<src.length;i++){
        var e = src[i];
        if (!e) continue;
        if (e.terms && typeof e.terms === "object"){
          if (e.terms.fr) out.push(e.terms.fr);
        }else{
          if (e.term_fr) out.push(e.term_fr);
          if (e.fr) out.push(e.fr);
          if (e.name) out.push(e.name);
          if (e.label) out.push(e.label);
        }
      }
    }
    return uniqTerms(out);
  }

  function getProtectTerms(){
    if (_protectTerms) return _protectTerms;
    _protectTerms = buildProtectTerms();
    return _protectTerms;
  }

  function protectLexiconInElement(el){
    if (!el) return;
    var txt = el.textContent || "";
    if (!txt.trim()) return;

    var terms = getProtectTerms();
    if (!terms.length) return;

    var safe = escapeHtml(txt);
    var capped = terms.slice(0, 500).map(escapeRegExp);
    if (!capped.length) return;

    try{
      var re = new RegExp("(" + capped.join("|") + ")", "g");
      safe = safe.replace(re, function(m){
        return '<span class="notranslate" translate="no" data-po-lex-protect="1">' + m + '</span>';
      });
      el.innerHTML = safe;
    }catch(_){}
  }

  /* =========================
     CONTENU TRILINGUE (slots généraux)
     ========================= */
  var CONTENT = {
    fr: {
      head_title: "Clavier des 33 éléments",
      head_meta: "blocs → touches",

      main_summary_title: "Brève présentation : Les 33 éléments",
      main_summary_meta: "4 groupes",

      k1_summary_title: "KATÛPIRSIA 1 - Axis",
      k1_summary_meta: "Fondation · Outils · Engrenages",
      k1_block1_title: "Fondation & piliers",
      k1_block2_title: "Outils",
      k1_block3_title: "Engrenages",

      k2_summary_title: "KATÛPIRSIA 2 - Les Fondamenteurs",
      k2_summary_meta: "18 modalités · 6 familles",
      k2_block_title: "18 Modalités opératives",
      fam_temporalites: "Famille des Temporalités",
      fam_consciences: "Famille des Consciences",
      fam_lucidites: "Famille des Lucidités",
      fam_adaptabilites: "Famille des Adaptabilités",
      fam_decisions: "Famille des Décisions",
      fam_devenirs: "Famille des Devenirs",

      k3_summary_title: "KATÛPIRSIA 3 - Katûvýsissence",
      k3_summary_meta: "Pratiques · Univers",
      k3_block1_title: "Pratiques",
      k3_block2_title: "Univers",

      annexe_summary_title: "Annexe K1",
      annexe_summary_meta: "2 entrées",
      annexe_block_title: "Annexes K1"
    },
    en: {
      head_title: "Keyboard of the 33 elements",
      head_meta: "blocks → keys",

      main_summary_title: "Brief presentation: The 33 elements",
      main_summary_meta: "4 groups",

      k1_summary_title: "KATÛPIRSIA 1 - Axis",
      k1_summary_meta: "Foundation · Tools · Gears",
      k1_block1_title: "Foundation & pillars",
      k1_block2_title: "Tools",
      k1_block3_title: "Gears",

      /* ✅ Fondamenteurs reste canonique */
      k2_summary_title: "KATÛPIRSIA 2 - Les Fondamenteurs",
      k2_summary_meta: "18 modalities · 6 families",
      k2_block_title: "18 Operative modalities",
      fam_temporalites: "Temporalities family",
      fam_consciences: "Consciousness family",
      fam_lucidites: "Lucidities family",
      fam_adaptabilites: "Adaptabilities family",
      fam_decisions: "Decisions family",
      fam_devenirs: "Becomings family",

      k3_summary_title: "KATÛPIRSIA 3 - Katûvýsissence",
      k3_summary_meta: "Practices · Universes",
      k3_block1_title: "Practices",
      k3_block2_title: "Universes",

      annexe_summary_title: "Appendix K1",
      annexe_summary_meta: "2 entries",
      annexe_block_title: "K1 appendices"
    },
    es: {
      head_title: "Teclado de los 33 elementos",
      head_meta: "bloques → teclas",

      main_summary_title: "Breve presentación: Los 33 elementos",
      main_summary_meta: "4 grupos",

      k1_summary_title: "KATÛPIRSIA 1 - Axis",
      k1_summary_meta: "Fundación · Herramientas · Engranajes",
      k1_block1_title: "Fundación y pilares",
      k1_block2_title: "Herramientas",
      k1_block3_title: "Engranajes",

      /* ✅ Fondamenteurs reste canonique */
      k2_summary_title: "KATÛPIRSIA 2 - Los Fondamenteurs",
      k2_summary_meta: "18 modalidades · 6 familias",
      k2_block_title: "18 Modalidades operativas",
      fam_temporalites: "Familia de las Temporalidades",
      fam_consciences: "Familia de las Consciencias",
      fam_lucidites: "Familia de las Lucideces",
      fam_adaptabilites: "Familia de las Adaptabilidades",
      fam_decisions: "Familia de las Decisiones",
      fam_devenirs: "Familia de los Devenires",

      k3_summary_title: "KATÛPIRSIA 3 - Katûvýsissence",
      k3_summary_meta: "Prácticas · Universos",
      k3_block1_title: "Prácticas",
      k3_block2_title: "Universos",

      annexe_summary_title: "Anexo K1",
      annexe_summary_meta: "2 entradas",
      annexe_block_title: "Anexos K1"
    }
  };

  function getPack(lang){
    var l = normLang(lang || getLang());
    return CONTENT[l] || CONTENT.fr;
  }

  /* =========================
     LEXIQUE (window.PO_LEXICON)
     ========================= */
  var ALIAS = {
    /* "superposition-de-perspectives": "superposition_de_perspectives" */
  };

  function buildIndex(){
    var src = window.PO_LEXICON;
    if (!Array.isArray(src)){
      if (Array.isArray(window.PO_LEXICON_DATA)) src = window.PO_LEXICON_DATA;
      else if (Array.isArray(window.PO_LEXICON_ENTRIES)) src = window.PO_LEXICON_ENTRIES;
    }
    if (!Array.isArray(src) || !src.length) return null;

    var exact = Object.create(null);
    var normd = Object.create(null);

    for (var i=0;i<src.length;i++){
      var e = src[i];
      if (!e) continue;
      var id = e.id || e.slug || e.key || e.uid;
      if (!id) continue;

      var idStr = String(id);
      exact[idStr] = e;

      var nk = normalizeVariant(idStr).toLowerCase().replace(/[^a-z0-9_-]+/g, "-").replace(/-+/g,"-").replace(/^[-_]+|[-_]+$/g,"");
      if (nk && !normd[nk]) normd[nk] = e;
    }
    return { exact: exact, normd: normd };
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    if (entry.terms && typeof entry.terms === "object"){
      return entry.terms[lang] || entry.terms.fr || "";
    }
    var k = "term_" + lang;
    if (entry[k]) return String(entry[k]);
    if (entry.term_fr) return String(entry.term_fr);
    if (entry[lang]) return String(entry[lang]);
    if (entry.fr) return String(entry.fr);
    if (entry.name) return String(entry.name);
    if (entry.label) return String(entry.label);
    return "";
  }

  function normLookupKey(s){
    s = toStr(s).trim().toLowerCase();
    s = s.replace(/œ/g, "oe").replace(/æ/g, "ae");
    s = s.replace(/[’'`´]/g, "'");
    try{ s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }catch(_){}
    s = s.replace(/[^a-z0-9_-]+/g, "-");
    s = s.replace(/-+/g, "-").replace(/^[-_]+|[-_]+$/g, "");
    return s;
  }

  function applySlots(root, lang){
    var pack = getPack(lang);
    var nodes = root.querySelectorAll("[data-po33b-slot]");
    for (var i=0;i<nodes.length;i++){
      var el = nodes[i];
      var key = el.getAttribute("data-po33b-slot");
      if (!key) continue;
      if (!Object.prototype.hasOwnProperty.call(pack, key)) continue;
      el.textContent = pack[key];
      protectLexiconInElement(el);
    }
  }

  function applyLexicon(root /*, lang */){
    var idx = buildIndex();
    if (!idx) return;

    var nodes = root.querySelectorAll("[data-po-lex]");
    for (var i=0;i<nodes.length;i++){
      var el = nodes[i];
      var id = el.getAttribute("data-po-lex");
      if (!id) continue;

      var lookup = ALIAS[id] || id;
      var entry = idx.exact[lookup];

      if (!entry){
        var nk = normLookupKey(lookup);
        if (nk) entry = idx.normd[nk];
      }
      if (!entry){
        var nk2 = normLookupKey(el.textContent || "");
        if (nk2) entry = idx.normd[nk2];
      }

      /* ✅ IMPORTANT : le lexique canonique reste TOUJOURS EN FR */
      if (entry){
        var txtFr = pickTerm(entry, "fr");
        if (txtFr) el.textContent = txtFr;
      }

      if (el.getAttribute("data-po-protect") === "1"){
        try{
          el.setAttribute("translate","no");
          el.classList.add("notranslate");
        }catch(_){}
      }

      protectLexiconInElement(el);
    }
  }

  function setLangButtonsState(root, lang){
    var btns = root.querySelectorAll("[data-po33b-lang]");
    for (var i=0;i<btns.length;i++){
      var b = btns[i];
      var on = (b.getAttribute("data-po33b-lang") === lang);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    }
  }

  function applyOne(root, lang){
    var l = normLang(lang || getLang());
    lockNoTranslate(root, l);

    applySlots(root, l);   /* ✅ textes hors lexique = traduisibles */
    applyLexicon(root);    /* ✅ lexique canonique = FR constant */
    setLangButtonsState(root, l);
  }

  function applyAll(lang){
    var l = normLang(lang || getLang());
    var roots = document.querySelectorAll("[data-po33b]");
    for (var i=0;i<roots.length;i++){
      applyOne(roots[i], l);
    }
    try{
      document.dispatchEvent(new CustomEvent("po:po33b:lang", { detail:{ lang:l } }));
    }catch(_){}
  }

  function hookLangButtons(){
    document.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest("[data-po33b-lang]") : null;
      if (!btn) return;
      ev.preventDefault();
      setLang(btn.getAttribute("data-po33b-lang") || "fr");
    }, false);
  }

  /* Accordéon exclusif pour les sous-groupes d’un même bloc principal */
  function initExclusiveSubAccordions(){
    var mains = document.querySelectorAll("[data-po33b-main]");
    for (var m=0; m<mains.length; m++){
      (function(main){
        var subs = main.querySelectorAll("[data-po33b-subacc]");
        for (var i=0; i<subs.length; i++){
          subs[i].addEventListener("toggle", function(ev){
            var current = ev.currentTarget;
            if (!current.open) return;
            for (var j=0; j<subs.length; j++){
              if (subs[j] !== current) subs[j].open = false;
            }
          }, { passive:true });
        }
      })(mains[m]);
    }
  }

  function onReady(fn){
    if (document.readyState === "loading"){
      document.addEventListener("DOMContentLoaded", fn, { passive:true });
    } else {
      fn();
    }
  }

  function init(){
    applyAll(getLang());
    initExclusiveSubAccordions();
  }

  window.Po33bTriLangProtected = {
    init: init,
    setLang: setLang,
    getLang: getLang,
    applyAll: applyAll,
    applyOne: applyOne
  };

  onReady(function(){
    hookLangButtons();
    init();
  });
})();